import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  class: "container",
  style: {"margin-top":"80px","padding-top":"40px"}
}
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-lg-6 text-right" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "container" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { class: "card-deck" }
const _hoisted_8 = { class: "card bg-light mb-3" }
const _hoisted_9 = { class: "card-body" }
const _hoisted_10 = { class: "card-text" }
const _hoisted_11 = { class: "card text-dark bg-light mb-3" }
const _hoisted_12 = { class: "card-footer" }
const _hoisted_13 = { class: "form-check" }
const _hoisted_14 = { key: 0 }
const _hoisted_15 = { class: "fg-color-red" }
const _hoisted_16 = { key: 1 }
const _hoisted_17 = { class: "table table-bordered" }
const _hoisted_18 = ["onUpdate:modelValue"]
const _hoisted_19 = ["value"]
const _hoisted_20 = { class: "error SpreadsheetError" }
const _hoisted_21 = ["onClick"]
const _hoisted_22 = {
  key: 2,
  style: {"height":"100%"}
}
const _hoisted_23 = { key: 0 }
const _hoisted_24 = { class: "row" }
const _hoisted_25 = { class: "col-sm-3" }
const _hoisted_26 = { class: "col-sm-3" }
const _hoisted_27 = { class: "col-sm-3" }
const _hoisted_28 = { class: "col-sm-3" }
const _hoisted_29 = { style: {"overflow-x":"hidden","font-family":"'Consolas', 'Courier New', monospace","line-height":"1.5","font-size":"16px"} }
const _hoisted_30 = { key: 0 }
const _hoisted_31 = { class: "fg-color-red" }
const _hoisted_32 = { class: "fg-color-red" }
const _hoisted_33 = { key: 1 }
const _hoisted_34 = { class: "fg-color-red" }
const _hoisted_35 = { class: "fg-color-red" }
const _hoisted_36 = { key: 2 }
const _hoisted_37 = { class: "fg-color-green" }
const _hoisted_38 = { class: "fg-color-green" }
const _hoisted_39 = { key: 3 }
const _hoisted_40 = { class: "fg-color-green" }
const _hoisted_41 = { class: "fg-color-green" }
const _hoisted_42 = { key: 4 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AttributeEditorDialog = _resolveComponent("AttributeEditorDialog")!
  const _component_PortfolioOrDecisionNavigation = _resolveComponent("PortfolioOrDecisionNavigation")!
  const _component_FileUploader = _resolveComponent("FileUploader")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_AttributeEditorDialog, {
      viewModel: _ctx.attributeEditorDialog,
      onAttributeCreated: _ctx.loadAttribute
    }, null, 8 /* PROPS */, ["viewModel", "onAttributeCreated"]),
    _createVNode(_component_PortfolioOrDecisionNavigation, {
      workspaceId: _ctx.workspaceId,
      projectId: _ctx.projectId
    }, null, 8 /* PROPS */, ["workspaceId", "projectId"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _cache[7] || (_cache[7] = _createElementVNode("div", { class: "col-lg-6" }, [
          _createElementVNode("h1", { style: {"font-size":"2em","font-weight":"300","color":"#33475b","margin":"0"} }, "Import")
        ], -1 /* CACHED */)),
        _createElementVNode("div", _hoisted_3, [
          (!_ctx.Processing)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                (_ctx.ImportStep === 'mappings')
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      type: "button",
                      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.cancelImport && _ctx.cancelImport(...args))),
                      class: "btn btn-outline-secondary mr-1",
                      style: {"padding":"0.7em 2em"}
                    }, "Back"))
                  : _createCommentVNode("v-if", true),
                (_ctx.NextToAlternativesAttributesMappingsButtonVisible)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 1,
                      type: "button",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.ImportStep = 'mappings')),
                      class: "btn btn-outline-secondary",
                      style: {"padding":"0.7em 2em"}
                    }, "Next"))
                  : _createCommentVNode("v-if", true),
                (_ctx.ImportStep === 'mappings')
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 2,
                      type: "button",
                      onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.handleImportAlternativesFromSpreadsheetCommand && _ctx.handleImportAlternativesFromSpreadsheetCommand(...args))),
                      class: "btn btn-primary",
                      style: {"padding":"0.7em 2em"}
                    }, "Import"))
                  : _createCommentVNode("v-if", true)
              ]))
            : _createCommentVNode("v-if", true)
        ])
      ])
    ]),
    _cache[36] || (_cache[36] = _createElementVNode("hr", { style: {"border-color":"#bbb","margin":"20px 0 60px"} }, null, -1 /* CACHED */)),
    _createElementVNode("div", _hoisted_5, [
      (_ctx.ImportStep === 'source')
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _cache[9] || (_cache[9] = _createElementVNode("h5", { class: "card-title" }, "Import tips", -1 /* CACHED */)),
                  _createElementVNode("p", _hoisted_10, [
                    _cache[8] || (_cache[8] = _createTextVNode(" The best way to import your data is to use our ", -1 /* CACHED */)),
                    _createElementVNode("a", {
                      onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.handleDownloadEmptyAlternativesSpreadsheetCommand && _ctx.handleDownloadEmptyAlternativesSpreadsheetCommand(...args))),
                      class: "text-primary"
                    }, "sample import file")
                  ]),
                  _cache[10] || (_cache[10] = _createElementVNode("p", { class: "card-text" }, " If you want to use your custom file, here are our recommendations about its structure: ", -1 /* CACHED */)),
                  _cache[11] || (_cache[11] = _createElementVNode("ul", null, [
                    _createElementVNode("li", null, "Use columns as attributes and rows as data"),
                    _createElementVNode("li", null, "Include \"Name\" column to indicate unique name"),
                    _createElementVNode("li", null, "Optionally include \"Description\" column to indicate description to be used"),
                    _createElementVNode("li", null, "Avoid merged cells, images, charts")
                  ], -1 /* CACHED */))
                ])
              ]),
              _createElementVNode("div", _hoisted_11, [
                _cache[13] || (_cache[13] = _createElementVNode("div", { class: "card-body" }, [
                  _createElementVNode("h5", { class: "card-title text-danger" }, "DANGER: YOUR DATA MAY BE DELETED"),
                  _createElementVNode("p", { class: "card-text" }, " When importing data from a spreadsheet, you can choose whether or not to import data for existing projects/alternatives. When you do import these data, any blanks in your spreadsheet will effectively \"delete\" any data already in TransparentChoice. ")
                ], -1 /* CACHED */)),
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("div", _hoisted_13, [
                    _withDirectives(_createElementVNode("input", {
                      class: "form-check-input",
                      type: "checkbox",
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.UpdateExisting) = $event))
                    }, null, 512 /* NEED_PATCH */), [
                      [_vModelCheckbox, _ctx.UpdateExisting]
                    ]),
                    _cache[12] || (_cache[12] = _createElementVNode("label", { class: "form-check-label" }, " Check this box to update data for existing alternatives. Leave it unchecked if you only want to add new alternatives from your spreadsheet. ", -1 /* CACHED */))
                  ])
                ])
              ])
            ]),
            _cache[15] || (_cache[15] = _createElementVNode("br", null, null, -1 /* CACHED */)),
            _cache[16] || (_cache[16] = _createElementVNode("h4", null, "Choose file to import (.xls or .xlsx)", -1 /* CACHED */)),
            _createVNode(_component_FileUploader, {
              onSelected: _cache[5] || (_cache[5] = ($event: any) => (_ctx.file=$event)),
              onUnselected: _cache[6] || (_cache[6] = ($event: any) => (_ctx.file=null)),
              onUploaded: _ctx.loadMappings
            }, null, 8 /* PROPS */, ["onUploaded"]),
            (_ctx.rm && _ctx.rm.HasErrors)
              ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.SpreadsheetErrors, (err) => {
                    return (_openBlock(), _createElementBlock("strong", _hoisted_15, _toDisplayString(err), 1 /* TEXT */))
                  }), 256 /* UNKEYED_FRAGMENT */)),
                  _cache[14] || (_cache[14] = _createElementVNode("br", null, null, -1 /* CACHED */))
                ]))
              : _createCommentVNode("v-if", true)
          ]))
        : _createCommentVNode("v-if", true),
      (_ctx.ImportStep === 'mappings')
        ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
            _cache[22] || (_cache[22] = _createElementVNode("h4", null, "Map columns to attributes", -1 /* CACHED */)),
            _createElementVNode("table", _hoisted_17, [
              _cache[21] || (_cache[21] = _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", { scope: "col" }, "Column name"),
                  _createElementVNode("th", { scope: "col" }, "Attribute name"),
                  _createElementVNode("th", { scope: "col" })
                ])
              ], -1 /* CACHED */)),
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rm.Mappings, (m) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: m.ColumnName,
                    class: _normalizeClass({'table-warning': m.PropertyName === 'None'})
                  }, [
                    _createElementVNode("td", null, _toDisplayString(m.ColumnName), 1 /* TEXT */),
                    _createElementVNode("td", null, [
                      _withDirectives(_createElementVNode("select", {
                        class: "Value form-control",
                        "onUpdate:modelValue": ($event: any) => ((m.PropertyName) = $event)
                      }, [
                        _cache[17] || (_cache[17] = _createElementVNode("option", { value: "None" }, "[Do not import]", -1 /* CACHED */)),
                        _cache[18] || (_cache[18] = _createElementVNode("option", { value: "Name" }, "Name", -1 /* CACHED */)),
                        _cache[19] || (_cache[19] = _createElementVNode("option", { value: "Description" }, "Description", -1 /* CACHED */)),
                        _cache[20] || (_cache[20] = _createElementVNode("option", { value: "Status" }, "Status", -1 /* CACHED */)),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.AttributesOrdered, (attr) => {
                          return (_openBlock(), _createElementBlock("option", {
                            value: attr.Name,
                            key: attr.Id
                          }, _toDisplayString(attr.Name), 9 /* TEXT, PROPS */, _hoisted_19))
                        }), 128 /* KEYED_FRAGMENT */))
                      ], 8 /* PROPS */, _hoisted_18), [
                        [_vModelSelect, m.PropertyName]
                      ]),
                      _createElementVNode("div", _hoisted_20, _toDisplayString(m.Error), 1 /* TEXT */)
                    ]),
                    _createElementVNode("td", null, [
                      _createElementVNode("button", {
                        onClick: ($event: any) => (_ctx.showAttributeCreator(m)),
                        type: "button",
                        class: "btn btn-outline-secondary"
                      }, "Create attribute", 8 /* PROPS */, _hoisted_21)
                    ])
                  ], 2 /* CLASS */))
                }), 128 /* KEYED_FRAGMENT */))
              ])
            ]),
            _cache[23] || (_cache[23] = _createElementVNode("br", null, null, -1 /* CACHED */))
          ]))
        : _createCommentVNode("v-if", true),
      (_ctx.ImportStep === 'summary')
        ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
            _createElementVNode("h4", null, _toDisplayString(_ctx.ImportCompleted ? 'Import completed' : 'Import in progress...'), 1 /* TEXT */),
            (_ctx.importResult)
              ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                  _createElementVNode("div", _hoisted_24, [
                    _createElementVNode("div", _hoisted_25, [
                      _cache[24] || (_cache[24] = _createElementVNode("p", null, [
                        _createElementVNode("strong", null, "New:")
                      ], -1 /* CACHED */)),
                      _createElementVNode("h4", null, _toDisplayString(_ctx.importResult.Created.length), 1 /* TEXT */)
                    ]),
                    _createElementVNode("div", _hoisted_26, [
                      _cache[25] || (_cache[25] = _createElementVNode("p", null, [
                        _createElementVNode("strong", null, "Existing:")
                      ], -1 /* CACHED */)),
                      _createElementVNode("h4", null, _toDisplayString(_ctx.importResult.Updated.length + _ctx.importResult.NotChanged.length), 1 /* TEXT */)
                    ]),
                    _createElementVNode("div", _hoisted_27, [
                      _cache[26] || (_cache[26] = _createElementVNode("p", null, [
                        _createElementVNode("strong", null, "Processed:")
                      ], -1 /* CACHED */)),
                      _createElementVNode("h4", null, _toDisplayString(_ctx.importResult.Created.length + _ctx.importResult.Updated.length + _ctx.importResult.NotChanged.length), 1 /* TEXT */)
                    ]),
                    _createElementVNode("div", _hoisted_28, [
                      _cache[27] || (_cache[27] = _createElementVNode("p", null, [
                        _createElementVNode("strong", null, "Failed:")
                      ], -1 /* CACHED */)),
                      _createElementVNode("h4", null, _toDisplayString(_ctx.importResult.FailedToCreate.length + _ctx.importResult.FailedToUpdate.length), 1 /* TEXT */)
                    ])
                  ]),
                  _cache[35] || (_cache[35] = _createElementVNode("br", null, null, -1 /* CACHED */)),
                  _createElementVNode("div", _hoisted_29, [
                    (_ctx.importResult.FailedToCreate.length)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                          _createElementVNode("strong", _hoisted_31, "Failed to create (" + _toDisplayString(_ctx.importResult.FailedToCreate.length) + ")", 1 /* TEXT */),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.importResult.FailedToCreate, (a) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: `create-${a}`,
                              style: {"margin-left":"20px"}
                            }, [
                              _createElementVNode("span", _hoisted_32, _toDisplayString(a), 1 /* TEXT */),
                              _cache[28] || (_cache[28] = _createTextVNode()),
                              _createElementVNode("span", null, _toDisplayString(_ctx.getError(a)), 1 /* TEXT */),
                              _cache[29] || (_cache[29] = _createElementVNode("br", null, null, -1 /* CACHED */))
                            ]))
                          }), 128 /* KEYED_FRAGMENT */))
                        ]))
                      : _createCommentVNode("v-if", true),
                    (_ctx.importResult.FailedToUpdate.length)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                          _createElementVNode("strong", _hoisted_34, "Failed to update (" + _toDisplayString(_ctx.importResult.FailedToUpdate.length) + ")", 1 /* TEXT */),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.importResult.FailedToUpdate, (a) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: `update-${a}`,
                              style: {"margin-left":"20px"}
                            }, [
                              _createElementVNode("span", _hoisted_35, _toDisplayString(a), 1 /* TEXT */),
                              _cache[30] || (_cache[30] = _createTextVNode()),
                              _createElementVNode("span", null, _toDisplayString(_ctx.getError(a)), 1 /* TEXT */),
                              _cache[31] || (_cache[31] = _createElementVNode("br", null, null, -1 /* CACHED */))
                            ]))
                          }), 128 /* KEYED_FRAGMENT */))
                        ]))
                      : _createCommentVNode("v-if", true),
                    (_ctx.importResult.Created.length)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                          _createElementVNode("strong", _hoisted_37, "Created (" + _toDisplayString(_ctx.importResult.Created.length) + ")", 1 /* TEXT */),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.importResult.Created, (a) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: `created-${a}`,
                              style: {"margin-left":"20px"}
                            }, [
                              _createElementVNode("span", _hoisted_38, _toDisplayString(a), 1 /* TEXT */),
                              _cache[32] || (_cache[32] = _createElementVNode("br", null, null, -1 /* CACHED */))
                            ]))
                          }), 128 /* KEYED_FRAGMENT */))
                        ]))
                      : _createCommentVNode("v-if", true),
                    (_ctx.importResult.Updated.length)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                          _createElementVNode("strong", _hoisted_40, "Updated (" + _toDisplayString(_ctx.importResult.Updated.length) + ")", 1 /* TEXT */),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.importResult.Updated, (a) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: `updated-${a}`,
                              style: {"margin-left":"20px"}
                            }, [
                              _createElementVNode("span", _hoisted_41, _toDisplayString(a), 1 /* TEXT */),
                              _cache[33] || (_cache[33] = _createElementVNode("br", null, null, -1 /* CACHED */))
                            ]))
                          }), 128 /* KEYED_FRAGMENT */))
                        ]))
                      : _createCommentVNode("v-if", true),
                    (_ctx.importResult.NotChanged.length)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                          _createElementVNode("strong", null, "No changes detected (" + _toDisplayString(_ctx.importResult.NotChanged.length) + ")", 1 /* TEXT */),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.importResult.NotChanged, (a) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: `notchanged-${a}`,
                              style: {"margin-left":"20px"}
                            }, [
                              _createElementVNode("span", null, _toDisplayString(a), 1 /* TEXT */),
                              _cache[34] || (_cache[34] = _createElementVNode("br", null, null, -1 /* CACHED */))
                            ]))
                          }), 128 /* KEYED_FRAGMENT */))
                        ]))
                      : _createCommentVNode("v-if", true)
                  ])
                ]))
              : _createCommentVNode("v-if", true)
          ]))
        : _createCommentVNode("v-if", true)
    ])
  ]))
}